<div class="zero-discussion" [style.height]="height" [style.row-gap.px]="gap">
    <span *ngIf="icon" class="material-symbols-outlined chat-icon" [ngClass]="{
        'background': !noIconBackground
    }">{{icon}}</span>
    <img class="chat-icon" *ngIf="fileIcon" [src]="fileIcon.src" [alt]="fileIcon.alt"/>
    <div *ngIf="heading" class="header">{{heading}}</div>
    <div *ngIf="content" class="body">{{content}}</div>
    <ng-content></ng-content>
</div>